import Vue from 'vue'
import VueRouter from 'vue-router'
import {authGuard, checkPolicy} from "./guards/authGuard"

Vue.use(VueRouter)

// Add a function to redirect : dashboard-audits or dashboard-installs

const routes = [
  { path: '/', redirect: '/dashboard-audits' },

  {
    path: '/test',
    name: 'test',
    component: () => import('../views/Test.vue'),
    beforeEnter: authGuard,
    hash: '',
    meta: {
      roles: ["admin"],
      label: "Test"
    }
  },

  {
    path: '/dashboard-audits',
    name: 'dashboard-audits',
    component: () => import('../views/Dashboard/Dashboard.vue'),
    beforeEnter: authGuard,
    hash: '',
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: "Mes audits"
    }
  },

  {
    path: '/dashboard-installs',
    name: 'dashboard-installations',
    component: () => import('../views/Dashboard/Dashboard.vue'),
    beforeEnter: authGuard,
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: "Mes installations"
    }
  },

  // {
  //   path: '/dashboard-fleet',
  //   name: 'dashboard-fleet',
  //   component: () => import('../views/Dashboard/fleet/fleet.vue'),
  //   beforeEnter: authGuard,
  //   hash: '',
  //   meta: {
  //     roles: ["admin", "data-analyst", "user-manager", "user"],
  //     //label: "fleet"
  //   }
  // },

  {
    name: 'installation-show-c-a',
    path: '/installations/show/calepinage-agencement/:id',
    component: () => import('../views/Experts/ExpertLayout.vue'),
//    component: () => import('../views/Installations/Show.vue'),
    beforeEnter: checkPolicy,
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: 'Diagnostic installation'
    }
  },
  {
    name: 'expert-module',
    path: '/expert-mod/:id/:expert/:sel_pdm',
    beforeEnter: checkPolicy,
    component: () => import('../views/Experts/MainExpert.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: 'Module Expert : '
    }
  },

  {
    name: 'expert-layout',
    path: '/expert-layout/:id/layout',
    beforeEnter: checkPolicy,
    component: () => import('../views/Experts/ExpertLayout.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: '_module_calepinage_ : '
    }
  },


  // Authentification
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'empty',
      roles: ["admin", "data-analyst", "user-manager", "user"]
    },
    component: () => import('../views/Auth/Login.vue'),

  },

  {
    path: '/logout',
    name: 'logout',
    meta: {
      layout: 'empty',
      roles: ["admin", "data-analyst", "user-manager", "user"]
    },
    component: () => import('../views/Auth/Logout.vue'),
  },

  {
    path: '/set-account/:token',
    name: 'set-account',
    meta: {
      layout: 'empty',
    },
    component: () => import('../views/Auth/SetAccount.vue'),
  },

  {
    path: '*',
    name: 'error',
    meta: {
      layout: 'empty',
    },
    component: () => import('../views/Error.vue'),
  },

  {
    path: '/tech/dashboard',
    name: 'techDashboard',
    meta: {

    },
    component: () => import('../views/Dashboard/TechDashboard.vue'),
  },

  {
    name: 'tech-map',
    path: '/tech/map/:id/',
    component: () => import('../views/Tech/TechMap.vue'),
  },

  {
    name: 'tech-instructions',
    path: '/tech/instructions/:id',
    component: () => import('../views/Tech/Instructions.vue'),
  },

  {
    name: 'tech-infos',
    path: '/tech/infos/:id',
    component: () => import('../views/Tech/TechInfos.vue'),
  },

  {
    name: 'installation-show-evenement',
    path: '/installations/show/evenement/:id',
    component: () => import('../views/Evenements.vue'),
  },
  {
    name: 'installation-visualisation',
    path: '/installations/show/visualisation/:id',
    component: () => import('../views/Visualisation.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      const position = {}
      if (to.hash) {
        position.selector = to.hash
        return false
      }
    }
  },
})

export default router
